const clamp = (n: number, lo: number, hi: number) =>
  Math.min(hi, Math.max(lo, n));

export const timeToX = (time: number, duration: number, width: number) => {
  if (!duration || !isFinite(duration)) return 0;
  return clamp((time / duration) * width, 0, width);
};

export const xToTime = (x: number, width: number, duration: number) => {
  if (!width || !isFinite(width)) return 0;
  return clamp((x / width) * duration, 0, duration);
};

const mmss = (seconds: number) => {
  const safe = isFinite(seconds) && seconds > 0 ? seconds : 0;
  const m = Math.floor(safe / 60);
  const s = Math.floor(safe % 60);
  return `${m}:${String(s).padStart(2, "0")}`;
};

export const formatElapsedOverTotal = (elapsed: number, total: number) =>
  `${mmss(elapsed)}/${mmss(total)}`;

export const buildEnvelopePath = (
  min: number[],
  max: number[],
  width: number,
  height: number
) => {
  const n = Math.min(min.length, max.length);
  if (n === 0) return "";

  const mid = height / 2;
  const scale = height / 2;
  const step = n - 1 || 1;

  let top = `M 0 ${mid}`;
  for (let i = 0; i < n; i += 1) {
    const x = (i / step) * width;
    const y = mid - clamp(max[i], -1, 1) * scale;
    top += ` L ${x.toFixed(2)} ${y.toFixed(2)}`;
  }

  let bottom = "";
  for (let i = n - 1; i >= 0; i -= 1) {
    const x = (i / step) * width;
    const y = mid - clamp(min[i], -1, 1) * scale;
    bottom += ` L ${x.toFixed(2)} ${y.toFixed(2)}`;
  }

  return `${top}${bottom} Z`;
};
